import React from "react";
import { MainContainer } from "./styles";
import { Avatar } from "antd";
import ThemeColors from "../../../../../themes/colors";
import { Column, Row } from "../../../../../themes/globalStyle";
import Typography from "../../../../../components/Typography";
import useAuth from "../../../../../hooks/useAuth";

const User: React.FC = (): JSX.Element => {
  const { authState } = useAuth();

  return (
    <MainContainer>
      <Avatar
        src={`https://api.dicebear.com/7.x/miniavs/svg?seed=${authState.accountData?.avatar}`}
        size={56}
        style={{ background: ThemeColors.Purple100 }}
      />
      <Column>
        <Typography
          text={`${authState.accountData?.friendly_name.split(" ")[0]},`}
          weight={600}
          size="large"
        />
        <Row style={{ gap: "1rem" }}>
          <Typography
            text={
              "Aproveite o fim das tarefas chatas para criar campanhas incríveis!"
            }
            weight={400}
            size="small"
            color="Black200"
          />
        </Row>
      </Column>
    </MainContainer>
  );
};

export default User;
